/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ReviewsAndRatings = function () {
  function ReviewsAndRatings(NPI) {
    _classCallCheck(this, ReviewsAndRatings);
    if (NPI) {
      this.NPI = NPI;
    } else {
      this.NPI = '-1';
      var npiSelector = document.querySelector('.field--name-field-provider-npi-number.field__item');
      if (npiSelector) {
        this.NPI = npiSelector.textContent;
      }
    }
    this.start = 0;
    this.STARS_ONLY_WIDGET = "https://widgets.reputation.com/widgets/5d51554bf35e671c67694053/run?tk=41a5eb11b43&lk=".concat(this.NPI);
  }
  return _createClass(ReviewsAndRatings, [{
    key: "fetchRatingsAndReviews",
    value: function fetchRatingsAndReviews($) {
      this.starsOnlyWidget($);
      this.reviewsWidget($);
    }
  }, {
    key: "addStarRatingToOverallSelector",
    value: function addStarRatingToOverallSelector($, selector, response) {
      var _this = this;
      if (selector.children.length < 1) {
        var parser = new DOMParser();
        selector.prepend(parser.parseFromString(response, 'text/html').body.firstElementChild);
        document.querySelectorAll('.provider-star-ratings .rating .count span').forEach(function (element) {
          element.textContent = " ".concat($("#ratings-label-".concat(_this.NPI))[0].textContent);
        });
      }
    }
  }, {
    key: "setStarRating",
    value: function setStarRating($, response) {
      var _this2 = this;
      if (response) {
        if (response.indexOf('error-container') < 1) {
          var $overallSelector = document.querySelectorAll("#overall-".concat(this.NPI));
          if ($overallSelector.length > 0) {
            $overallSelector.forEach(function (selector) {
              _this2.addStarRatingToOverallSelector($, selector, response);
            });
          } else {
            $('.overall-star-rating').prepend(response);
          }
        } else {
          this.showNoReviewLink();
        }
      }
    }
  }, {
    key: "setReviews",
    value: function setReviews($, response) {
      $('#reviews').html(response);
      var next = document.querySelectorAll('.field--name-field-review-pagination-next .field__item');
      var prev = document.querySelectorAll('.field--name-field-pagination-previous .field__item');
      var survey = document.querySelectorAll('.field--name-field-survey-response-label .field__item');
      var nextText = next[next.length - 1].innerHTML;
      var prevText = prev[prev.length - 1].innerHTML;
      var surveyText = survey[survey.length - 1].innerHTML;
      var $nextButton = $('.pagination .next-page a');
      var $prevButton = $('.pagination .previous-page a');
      $nextButton.addClass('base-button underline');
      $prevButton.addClass('base-button underline');
      $nextButton.html(nextText);
      $prevButton.html(prevText);
      $('.reviewer .reviewer-name').html(surveyText);
      $('.summary .info .separator').html('');
      this.setListeners($);
    }
  }, {
    key: "showNoReviewLink",
    value: function showNoReviewLink() {
      var providerProfileNoRatingsLink = document.querySelectorAll('.field--name-field-no-ratings-link .field__item a');
      var schedulingResultsNoRatingsLink = document.querySelectorAll("#no-star-".concat(this.NPI, " a"));
      var noRatingsLink = providerProfileNoRatingsLink.length > 0 ? providerProfileNoRatingsLink : schedulingResultsNoRatingsLink;
      if (noRatingsLink.length > 0) {
        document.querySelectorAll('.field--name-field-ratings-label').forEach(function (ratings) {
          ratings.classList.add('hidden');
        });
        noRatingsLink.forEach(function (link) {
          link.classList.remove('hidden');
          link.closest('.no-star-ratings').classList.remove('hidden');
        });
      }
    }
  }, {
    key: "starsOnlyWidget",
    value: function starsOnlyWidget($) {
      var _this3 = this;
      fetch(this.STARS_ONLY_WIDGET).then(function (response) {
        if (response.status === 404) {
          _this3.showNoReviewLink();
          return null;
        }
        return response.text();
      }).then(function (response) {
        _this3.setStarRating($, response);
      }).catch(function () {});
    }
  }, {
    key: "reviewsWidget",
    value: function reviewsWidget($) {
      var _this4 = this;
      var REVIEWS_WIDGET = "https://widgets.reputation.com/widgets/5dceae0bafae734a7ee24e7d/run?tk=41a5eb11b43&start=".concat(this.start, "&lk=").concat(this.NPI);
      fetch(REVIEWS_WIDGET).then(function (response) {
        if (response.status === 404) {
          _this4.showNoReviewLink();
          ReviewsAndRatings.hideProviderProfileSection();
          return null;
        }
        return response.text();
      }).then(function (response) {
        return _this4.setReviews($, response);
      }).catch(function () {});
    }
  }, {
    key: "setListeners",
    value: function setListeners($) {
      var _this5 = this;
      var paginationLinks = document.querySelectorAll('.reviews .pagination a');
      paginationLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          _this5.updateReviewPagination($, event.target);
        });
        link.addEventListener('keypress', function (event) {
          event.preventDefault();
          _this5.updateReviewPagination($, event.target);
        });
      });
    }
  }, {
    key: "updateReviewPagination",
    value: function updateReviewPagination($, element) {
      var href = element.href;
      var searchParams = new URLSearchParams(href);
      this.start = searchParams.get('start');
      this.reviewsWidget($);
    }
  }], [{
    key: "hideProviderProfileSection",
    value: function hideProviderProfileSection() {
      document.querySelector('.reviews-and-ratings').classList.add('hidden');
      var lastProviderSections = document.querySelectorAll('.provider-section:not(.hidden)');
      lastProviderSections[lastProviderSections.length - 1].classList.add('last-provider-section');
    }
  }]);
}();
export { ReviewsAndRatings as default };
(function () {})(Drupal);